import {sendAmplitudeEvent} from '#/analytics/amplitude-events';
import {Modal} from '#/atoms/modal';
import {useModalContext} from '#/contexts/modal-provider';
import {useWalletProvider} from '#/contexts/wallet-provider';
import {FunctionComponent, useState} from 'react';
import {useTranslation} from 'react-i18next';

type InvestmentRange = '$0 - $2,500' | '$2,500 - $5,000' | '$5,000 - $10,000' | '$10,000+';

export type SurveyModalProps = {
  // Add any props you need
};

export const SurveyModal: FunctionComponent<SurveyModalProps> = () => {
  const {t} = useTranslation('translation');
  const {close} = useModalContext();
  const {
    accountResult: {address},
  } = useWalletProvider();
  const [selectedInvestment, setSelectedInvestment] = useState<InvestmentRange | null>(null);

  const investmentRanges: InvestmentRange[] = ['$0 - $2,500', '$2,500 - $5,000', '$5,000 - $10,000', '$10,000+'];

  const handleSubmit = async () => {
    if (!selectedInvestment || !address) return;
    // Send to Amplitude
    sendAmplitudeEvent.submitSurvey({
      event_properties: {
        investment_range: selectedInvestment,
        wallet_address: address,
      },
    });

    close();
  };

  const handleClose = () => {
    sendAmplitudeEvent.optedOutSurvey({
      event_properties: {
        wallet_address: address as string,
      },
    });
    close();
  };

  return (
    <Modal
      title={t('survey.investmentTitle')}
      onClose={handleClose}
      hideOnClickAway={false}
      className='border-none rounded-xl'
    >
      <div className='p-4 flex justify-center'>
        <div className='flex flex-col gap-6 justify-center'>
          <div className='flex flex-col gap-4 justify-center'>
            <label className='text-lg font-semibold text-center'>{t('survey.investmentQuestion')}</label>
            <div className='flex flex-col gap-2'>
              {investmentRanges.map(range => (
                <button
                  key={range}
                  onClick={() => setSelectedInvestment(range)}
                  className={`w-full py-3 px-4 rounded-lg border transition-all ${
                    selectedInvestment === range
                      ? 'bg-deepblue text-white border-deepblue'
                      : 'border-gray-300 hover:border-deepblue text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  {range}
                </button>
              ))}
            </div>
          </div>

          <button
            onClick={handleSubmit}
            disabled={!selectedInvestment}
            className='w-full py-3 px-4 text-white bg-deepblue font-semibold rounded-lg focus:outline-none hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-opacity'
          >
            {t('actions.submit')}
          </button>
        </div>
      </div>
    </Modal>
  );
};
